import { Input, Paper, TextField, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import CustomRichText from '../../../components/customRichText/CustomRichText';
import {
  CategoryTranslationInput,
  TranslationInput,
} from '../../../config/types/custom/TranslationInput';
import { LanguageModel } from '../../../config/types/models';

type IProps = {
  description: string;
  translations: CategoryTranslationInput[];
  setDescription: (a: string) => void;
  setTranslations: (a: CategoryTranslationInput[]) => void;
  languages: LanguageModel[];
};

function CategoryDescription({
  description,
  translations,
  setDescription,
  setTranslations,
  languages,
}: IProps) {
  const t = useTranslate();

  const onChangeTranslation = (lang: LanguageModel, val: string) => {
    const newTranslations = [
      ...translations.filter(
        (c) => !(c.languageId === lang.id && c.key === 'description')
      ),
      {
        languageId: lang.id,
        key: 'description',
        value: val,
      },
    ];
    setTranslations(newTranslations);
  };

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant='subtitle1'>{t('categoryDescription')}</Typography>
      <CustomRichText
        content={description}
        placeholder={languages?.find((c) => c.isDefault === true)?.name || ''}
        onChange={(txt: string) => setDescription(txt)}
      />
      {languages
        ?.filter((c) => c.isDefault === false)
        .map((lang) => (
          <CustomRichText
            placeholder={lang.name}
            content={
              translations?.find(
                (c) => c.languageId === lang.id && c.key === 'description'
              )?.value || ''
            }
            onChange={(txt: string) => onChangeTranslation(lang, txt)}
          />
        ))}
    </Paper>
  );
}

export default CategoryDescription;
